import Spacer, { SpacerProps } from './Spacer';

export default Spacer;
export type { SpacerProps };
